<div class="snackbar-container">
  <img src="/assets/icons/tick-transparent.svg" alt="tick" />
  <p class="content-text">
    {{ data.message }}
    @if (data.linkText) {
      <a class="content-link" (click)="refreshPage()">{{ data.linkText }}</a>
    } 
  </p>
</div>
<button class="close-btn" (click)="closeSnackbar()">
  <img src="/assets/icons/close-icon.svg" alt="tick" />
</button>
